import { Routes, Route } from 'react-router-dom'
import SearchPage from './pages/SearchPage'
import MunicipalityDetailPage from './pages/MunicipalityDetailPage'
import { AdminLayout, Dashboard, ImportWizard, CSVImportWizard, GenesisImport, InkarImport, DeutschlandatlasImport, IndicatorsPage, EntityTable, RegionalisierungPage, TypisierungPage, StatistischeEntitaetenPage, JobsPage, UpdatesPage, QuarantinePage, FederalPage, ReportLayoutBuilder, ReportRatingEditor, PromptTemplates, GutachtenDashboard, DescriptionConfigEditor } from './admin'
import ErrorBoundary from './components/ErrorBoundary'
import UpdateNoticeBanner from './components/UpdateNoticeBanner'

function App() {
  return (
    <ErrorBoundary>
    <UpdateNoticeBanner />
    <Routes>
      {/* Main App Routes */}
      <Route path="/" element={<SearchPage />} />
      <Route path="/municipality/:id" element={<MunicipalityDetailPage />} />

      {/* Admin Routes */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="import" element={<ImportWizard />} />
        <Route path="import/csv" element={<CSVImportWizard />} />
        <Route path="genesis" element={<GenesisImport />} />
        <Route path="inkar" element={<InkarImport />} />
        <Route path="deutschlandatlas" element={<DeutschlandatlasImport />} />
        <Route path="indicators" element={<IndicatorsPage />} />
        <Route path="report-layout" element={<ReportLayoutBuilder />} />
        <Route path="rating-config" element={<ReportRatingEditor />} />
        <Route path="prompts" element={<PromptTemplates />} />
        <Route path="gutachten" element={<GutachtenDashboard />} />
        <Route path="description-config" element={<DescriptionConfigEditor />} />
        <Route path="jobs" element={<JobsPage />} />
        <Route path="updates" element={<UpdatesPage />} />
        <Route path="quarantine" element={<QuarantinePage />} />
        <Route path="federal" element={<FederalPage />} />
        <Route path="states" element={<EntityTable entityType="states" />} />
        <Route path="government-districts" element={<EntityTable entityType="government-districts" />} />
        <Route path="counties" element={<EntityTable entityType="counties" />} />
        <Route path="associations" element={<EntityTable entityType="municipal-associations" />} />
        <Route path="municipalities" element={<EntityTable entityType="municipalities" />} />

        {/* Regionalisierung, Typisierung & Statistische Regionen (Tabbed Pages) */}
        <Route path="regionalisierung" element={<RegionalisierungPage />} />
        <Route path="typisierung" element={<TypisierungPage />} />
        <Route path="statistische-entitaeten" element={<StatistischeEntitaetenPage />} />
      </Route>
    </Routes>
    </ErrorBoundary>
  )
}

export default App
